import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { formatPipe } from '../components/pages/threats/format.directive';
import { SplitPipe } from '../components/directives/split.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { formatDetails } from '../components/directives/format';


@NgModule({
  declarations: [
    formatPipe, SplitPipe, formatDetails
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatSidenavModule
  ],
  exports: [
    formatPipe, SplitPipe, formatDetails,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatSidenavModule,
  ]
})
export class GlobalModule { }
